var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("401 Nincs jogosultasa ezt az oldalt megtekinteni")]),_c('v-btn',{attrs:{"color":"primary","type":"submit"},on:{"click":function($event){return _vm.goHome()}}},[_vm._v("Vissza")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }